import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterModule],
  templateUrl: './bottom-nav.component.html',
  styleUrl: './bottom-nav.component.scss',
})
export class BottomNavComponent {
  constructor(private router: Router) {}

  isActive(path: string): boolean {
    const url = this.router.url;
    if (path === '/') {
      return url === '/' || url === '';
    }
    return url.startsWith(path);
  }
}